/**
 * WIDGET_COMPATIBLE_COMPS — maps each widget type to the list of
 * component types that are valid as field/dimension options.
 *
 * Single place to tweak per-widget field compatibility.
 * Consumed by each widget's config form when building field options.
 */
export const WIDGET_COMPATIBLE_COMPS = {
  WidgetMetricCard: [
    'NumberInput',
    'CheckboxList',
    'RadioList',
    'DropdownSingle',
    'DropdownMulti',
    'TagsInputSingle',
    'TagsInputMulti'
  ],
  // WidgetBarChart: [ ... ],
  // WidgetPieChart: [ ... ],
  // WidgetLineChart: [ ... ],
};

// Tag-input fields never show zero-count values: the "Hide Zero Values" switch is locked on.
export const isTagInput = (block) => ["TagsInputSingle", "TagsInputMulti"].includes(block?.comp);

export const hasTagInputDim = (props = {}) =>
  [props.dimension1, props.dimension2, props.dimension3, props.dimension4].some(isTagInput);

export const TAG_INPUT_HIDE_ZERO_TOOLTIP = "Your data is a tag field. Tag fields can't show zero values.";
